import React, { FunctionComponent, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { closeIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import cn from 'classnames';

import IconButton from '../../IconButton/IconButton';
import { Image } from '../imageGridTypes';

import styles from './ImageGridItem.scss';

interface GridItemProps {
  image: Image;
  className?: string;
  hideButton: boolean;
  isFlexibleSquare: boolean;
  onDelete?: () => void;
  onClick?: () => void;
  onKeyDown?: (event: KeyboardEvent) => void;
  onError?: (image: Image) => void;
}

const ImageGridItem: FunctionComponent<GridItemProps> = ({
  className,
  image,
  hideButton,
  isFlexibleSquare,
  onDelete,
  onClick = () => {},
  onKeyDown = () => {},
  onError = () => {},
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  const handleImageError = () => {
    onError(image);
  };

  const { alt, caption, url, loading } = image;

  return (
    <div
      aria-label={t('image.open')}
      tabIndex={0}
      role="button"
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={cn(className, styles.contentWrapper, {
        [styles.flexibleSquare]: isFlexibleSquare,
      })}
    >
      <div className={styles.content}>
        {!hideButton && onDelete && (
          <IconButton
            className={styles.closeButton}
            onClick={onDelete}
            aria-label={t('timeline.deleteGalleryItem')}
          >
            <Svg
              markup={closeIcon}
              className={cn(styles.center, styles.icon)}
            />
          </IconButton>
        )}
        <img
          className={cn({ [styles.unblur]: !loading }, styles.image)}
          alt={alt ?? caption ?? undefined}
          src={url}
          onError={handleImageError}
        />
      </div>
    </div>
  );
};

export default ImageGridItem;
